module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-en-69b14313574baf7b822884106b99ee27.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-en.svg
// module id = QjrU
// module chunks = 24